import { render, staticRenderFns } from "./storageDialog.vue?vue&type=template&id=80f452f8&scoped=true"
import script from "./storageDialog.vue?vue&type=script&lang=js"
export * from "./storageDialog.vue?vue&type=script&lang=js"
import style0 from "./storageDialog.vue?vue&type=style&index=0&id=80f452f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f452f8",
  null
  
)

export default component.exports